// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Container imports
const ContentProfileLayout = require('./component-dumb')

// Max # of likers to show in the article profile
const MAX_LIKERS_TO_SHOW = 7

function mapStateToProps(state) {
  const {
    // Flags
    isShareReferral,
    // Values
    embedUrl,
    likers,
    referredBy,
    title,
    thumbnail,
    url
  } = state.articleProfile
  return {
    // Flags
    isRedditVideo: getIsRedditVideo(state),
    isShareReferral,
    // Values
    embedUrl,
    iconId: getIconId(state),
    likers: likers.size > 0 ? getModifiedLikers(state) : null,
    likerCaption: getLikerCaption(state),
    provider: getProvider(state),
    referredBy,
    title,
    thumbnail,
    url
  }
}

function mapDispatchToProps() {

  function onLikerClick() {
    return async function () {
      await businessEvents.trackSegment('into-liker-click')
    }
  }

  return {
    onClick: onLikerClick()
  }
}

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ContentProfileLayout
)

module.exports = SmartComponent

const getProvider = createSelector(
  state => state.articleProfile.meta,
  meta => {
    const provider = meta.provider.toJS()
    provider.showStreamTitle = provider.id.toLowerCase() !== provider.streamTitle.toLowerCase()
    return provider
  }
)

const getIsRedditVideo = createSelector(
  getProvider,
  state => state.articleProfile.meta,
  (provider, meta) => provider.id === 'reddit' && (meta.media.find(mediaObject => mediaObject.has('mp4_url')) !== undefined)
)

const getIconId = createSelector(
  state => state.articleProfile.isShareReferral,
  isShared => isShared ? 'share-send' : 'heart'
)

const getLikerCaption = createSelector(
  state => state.articleProfile.likers,
  likers => {
    if (!likers.size) {
      return null
    }
    return `${likers.size} ${likers.size === 1 ? 'person' : 'people'} liked this`
  }
)

const getModifiedLikers = createSelector(
  state => state.articleProfile.likers,
  state => state.articleProfile.referredBy,
  (likers, referringUser) => {
    const filteredLikers = referringUser ? likers.filter(liker => liker.user_id !== referringUser.user_id) : likers
    return filteredLikers.slice(0, MAX_LIKERS_TO_SHOW)
  }
)
